import React from 'react'

const StorageContext = React.createContext({})
export default StorageContext
